import { G, Path, Svg } from '@react-pdf/renderer';
import { FC } from 'react';

interface Props {
	size?: number;
}

export const LogoPDF: FC<Props> = ({ size = 0.25 }) => {
	return (
		<Svg
			width={(1399 / 2.85) * size}
			height={(123 / 2.85) * size}
			viewBox="0 0 1399 123"
			fill="white"
		>
			<Path
				d="M500.8,11.3c-3.6,1.9-4.8,4.3-4.8,9.3c0.1,6.1,5.1,10.9,11.1,10.9c2,0,4-0.6,5.7-1.7c6.2-3.9,6.8-12.3,1.2-17.4
	C510.3,9.2,505,8.8,500.8,11.3z"
			/>
			<Path
				d="M13.9,17.7c-3.9,0.3-7.8,0.7-11.7,1.4L0,19.8v100.7l2.8,0.6c1.5,0.4,10.4,0.9,19.7,1.2c13.4,0.5,18.6,0.3,24.4-1
	c10.5-2.2,19.2-6.6,26-13.1c10.4-9.9,14.4-20.6,14.4-38.5c0-26.7-12.5-43.8-36.7-50C41.8,17.5,26.7,16.6,13.9,17.7z M49.8,36.6
	c6.5,2.9,13.4,10.3,15.7,16.9c4.2,12,2.6,29.6-3.6,39.3c-6,9.3-14.2,12.9-31.1,13.7L19,106.9V33.5l12.8,0.4
	C42.4,34.2,45.4,34.7,49.8,36.6z"
			/>
			<Path
				d="M720.5,20.2c-0.5,0.2-4.3,0.9-8.3,1.5l-7.3,1.2l0.3,40.7l0.3,40.6l2.7,5.7c3.3,7,8.7,11.2,16.6,12.9
	c6.6,1.3,16.6,0.7,23.8-1.5l5.2-1.6l-1.4-6.7c-0.8-3.7-1.6-6.9-1.9-7.1s-1.9,0.1-3.9,0.8c-5.5,1.8-15.1,1.6-18.1-0.4
	c-4.8-3.2-5.5-6.7-5.5-28.1V58.7h28v-15h-28v-12c0-6.6-0.3-12-0.7-11.9C721.7,19.8,721.1,19.9,720.5,20.2z"
			/>
			<Path
				d="M129.3,43.1C112.4,48.6,103,63.2,103,83.6c0,6.4,2.3,16.8,4.6,21.3c3,5.8,10.2,12.4,16.7,15.4c5.7,2.6,7.2,2.8,18.2,2.9
	s21.1-1.4,24.4-3.4c2.1-1.3-0.5-15.5-2.7-14.6c-6.9,2.6-24.3,3.5-29.6,1.5c-7-2.6-12.5-9.6-12.6-15.8v-2.2h51v-8.3
	c0-4.2-0.3-8.4-1-12.5c-2.5-10.8-9.3-19.7-17.8-23.4C148.4,41.9,135.2,41.1,129.3,43.1z M147,58.9c4.7,3.2,7.1,6.8,7.7,11.6l0.6,4.2
	h-16.7c-18.5,0-18,0.2-15.1-6.8C127.8,57.8,139,53.5,147,58.9z"
			/>
			<Path
				d="M210.1,42.7c-3.5,0.5-8.7,1.4-11.7,2l-5.4,1.1v75.9h17V58.9l2.3-0.6c4.2-1.1,15.8-0.6,19.3,0.9c2.6,1.1,4,2.6,5.7,6.2
	c2,4.5,2.2,6.7,2.5,30.5l0.4,25.8H258V99.4c0-12.2-0.5-25.6-1-29.7c-1.8-13.4-7.8-22-17.9-25.5C233.5,42.2,218.8,41.5,210.1,42.7z"
			/>
			<Path
				d="M302.5,43C283,49.5,272.9,67.5,276,90c2.9,20,15.8,32.5,34.6,33.5c23.6,1.3,39.4-15.2,39.4-41.1c0-17.2-8.1-31.2-21.7-37.4
	C321.6,41.9,308.8,41,302.5,43z M321.1,59.2c7.3,3.8,11.7,15.3,10.5,27.2c-1.6,15.9-11.2,24.6-23.4,21.3c-9.4-2.5-14.2-11-14.2-24.9
	c0-11.9,3.6-20.2,10.2-23.4C308.4,57.3,317.2,57.2,321.1,59.2z"
			/>
			<Path
				d="M386.8,42.7c-3.6,0.4-9.1,1.4-12.2,2.1L369,46v75.7h18V90.3c0-27.7,0.2-31.5,1.6-32c3.1-1.2,14.5-0.6,17.4,0.9
	c6.1,3.1,6.5,5.2,6.8,35.3l0.3,27.2h18l-0.3-28.2c-0.2-15.6-0.7-29.1-1.2-30.1c-1.9-4,14.3-7.5,20.8-4.5c1.4,0.6,3.6,3.2,4.8,5.7
	c2.2,4.4,2.3,6,2.6,30.9l0.4,26.2h18l-0.5-27.8c-0.5-29.2-1.2-34.2-5.3-40.5c-7.9-12-26.4-14.9-42.9-6.8c-5.9,3-6,3-8,1.1
	C414.4,42.9,401.2,40.9,386.8,42.7z"
			/>
			<Path
				d="M556.8,42.7c-3.6,0.5-9.1,1.4-12.2,2.1L539,46v75.7h18V58.9l2.3-0.6c5.2-1.4,16.2-0.6,19.4,1.4c6.4,3.9,6.8,5.6,7.1,35.2
	l0.3,26.8h18.1l-0.4-28.3c-0.4-26.2-0.5-28.6-2.6-33.7C595.4,45,581.8,39.8,556.8,42.7z"
			/>
			<Path
				d="M638.4,42.7c-7.3,1.3-10.7,2.8-10.1,4.4c0.6,2.3,1,4.6,1.2,7c0.6,4.6,1,5.6,2.4,5.1c0.9-0.2,4-0.9,7-1.5
	C656.2,54.5,666,59.3,666,71v4.4l-5.7-0.9c-16.3-2.7-32.7,3.3-37.4,13.6c-4.5,9.9-1.1,24.4,7,30s25.9,6.8,46.6,3.3l7-1.3l-0.1-28.4
	c0-24.4-0.3-29.1-1.7-32.9c-2.6-6.8-6.1-10.7-12.3-13.7c-4.8-2.3-7.1-2.8-15.8-3C648.5,41.9,643.4,42.1,638.4,42.7z M662.9,87.3
	l3.1,0.6v20.5l-6.4,0.7c-8.5,0.8-16-0.8-18.6-4.1c-2.8-3.6-2.7-10.4,0.3-13.7C644.7,87.4,654.4,85.6,662.9,87.3z"
			/>
			<Path
				d="M787.9,43.5c-16,5.3-25.9,20.3-25.9,39.2c0,12.7,6.2,27.3,14.1,33.3c8.1,6,11.7,7.1,22.9,7.2c9.9,0,10.9-0.2,17.2-3.3
	c11.3-5.5,17.7-15,20-29.5c3-19.5-5.8-38.5-20.9-45.4C807.8,41.6,795.8,40.9,787.9,43.5z M808,59.6c1.9,1,4.8,4,6.5,6.6
	c2.9,4.7,3,5.3,3,16.4c0,10.5-0.2,12-2.5,16.1c-6.2,11-19.6,13-28.1,4c-4.4-4.7-6.3-10.9-6.2-21.2c0-6.5,0.5-8.7,2.9-13.5
	c3.8-7.6,7.8-10.3,15.3-10.3C802,57.6,805.2,58.2,808,59.6z"
			/>
			<Path
				d="M876.5,42.3c-1.6,0.2-6.9,1.4-11.7,2.5l-8.8,2.1v74.8h17v-62l2.8-1.1c2.8-1.1,19.3-0.7,22.4,0.6c1.3,0.5,1.8-0.4,2.8-5.2
	c0.6-3.2,1.4-6.6,1.6-7.5c0.4-1.3-0.4-1.9-3.3-2.7C894.8,42.6,880.8,41.7,876.5,42.3z"
			/>
			<Path d="M498,82.7v39h18v-78h-18V82.7z" />
			<G>
				<Path
					d="M952.1,60.7c-0.7-2.1-1.4-4.2-2.1-6.4c-0.8-2.2-1.5-4.4-2.3-6.5h-23.4c-0.8,2.2-1.5,4.4-2.3,6.6c-0.8,2.2-1.5,4.3-2.1,6.4
		h-14c2.3-6.4,4.4-12.4,6.4-17.9c2-5.5,4-10.6,5.9-15.5s3.8-9.4,5.7-13.8c1.9-4.3,3.8-8.6,5.8-12.7h12.8c2,4.1,3.9,8.4,5.8,12.7
		c1.9,4.3,3.8,8.9,5.8,13.8c1.9,4.8,3.9,10,5.9,15.5c2,5.5,4.2,11.4,6.4,17.9H952.1z M936,14.5c-0.3,0.9-0.7,2.1-1.3,3.5
		c-0.6,1.5-1.2,3.2-2,5.2s-1.6,4.1-2.5,6.5s-1.8,4.8-2.8,7.4h17.1c-0.9-2.6-1.8-5.1-2.7-7.4c-0.9-2.4-1.7-4.5-2.4-6.5
		c-0.8-2-1.5-3.7-2-5.2C936.8,16.5,936.3,15.3,936,14.5z"
				/>
				<Path
					d="M987.3,51.5c2.4,0,4-0.2,5-0.7c1-0.5,1.5-1.4,1.5-2.7c0-1-0.6-1.9-1.9-2.7c-1.3-0.8-3.2-1.7-5.8-2.6
		c-2-0.7-3.8-1.5-5.5-2.3c-1.6-0.8-3-1.8-4.2-2.9c-1.2-1.1-2-2.5-2.7-4c-0.6-1.6-1-3.4-1-5.6c0-4.3,1.6-7.6,4.7-10.1
		c3.2-2.5,7.5-3.7,13-3.7c2.8,0,5.4,0.2,7.9,0.7c2.5,0.5,4.5,1,6,1.6l-2.2,10c-1.5-0.5-3.1-1-4.9-1.4c-1.8-0.4-3.7-0.6-5.9-0.6
		c-4,0-6,1.1-6,3.4c0,0.5,0.1,1,0.3,1.4c0.2,0.4,0.5,0.8,1,1.2c0.5,0.4,1.2,0.8,2.1,1.2c0.9,0.4,2,0.9,3.4,1.4c2.8,1,5.2,2.1,7,3.1
		c1.8,1,3.3,2.1,4.4,3.3c1.1,1.2,1.8,2.5,2.2,3.9s0.6,3.1,0.6,5c0,4.5-1.7,7.9-5,10.2c-3.4,2.3-8.1,3.4-14.3,3.4
		c-4,0-7.4-0.3-10.1-1c-2.7-0.7-4.5-1.3-5.6-1.7l2.2-10.4c2.2,0.9,4.4,1.5,6.7,2C982.8,51.3,985,51.5,987.3,51.5z"
				/>
				<Path
					d="M1029.1,51.5c2.4,0,4-0.2,5-0.7c1-0.5,1.5-1.4,1.5-2.7c0-1-0.6-1.9-1.9-2.7c-1.3-0.8-3.2-1.7-5.8-2.6
		c-2-0.7-3.8-1.5-5.5-2.3c-1.6-0.8-3-1.8-4.2-2.9c-1.2-1.1-2-2.5-2.7-4c-0.6-1.6-1-3.4-1-5.6c0-4.3,1.6-7.6,4.7-10.1
		c3.2-2.5,7.5-3.7,13-3.7c2.8,0,5.4,0.2,7.9,0.7c2.5,0.5,4.5,1,6,1.6l-2.2,10c-1.5-0.5-3.1-1-4.9-1.4c-1.8-0.4-3.7-0.6-5.9-0.6
		c-4,0-6,1.1-6,3.4c0,0.5,0.1,1,0.3,1.4c0.2,0.4,0.5,0.8,1,1.2c0.5,0.4,1.2,0.8,2.1,1.2c0.9,0.4,2,0.9,3.4,1.4c2.8,1,5.2,2.1,7,3.1
		c1.8,1,3.3,2.1,4.4,3.3c1.1,1.2,1.8,2.5,2.2,3.9s0.6,3.1,0.6,5c0,4.5-1.7,7.9-5,10.2c-3.4,2.3-8.1,3.4-14.3,3.4
		c-4,0-7.4-0.3-10.1-1c-2.7-0.7-4.5-1.3-5.6-1.7l2.2-10.4c2.2,0.9,4.4,1.5,6.7,2C1024.6,51.3,1026.9,51.5,1029.1,51.5z"
				/>
				<Path
					d="M1055.8,38.4c0-4,0.6-7.6,1.9-10.6c1.2-3,2.9-5.5,4.9-7.6c2-2,4.3-3.5,6.9-4.6c2.6-1,5.3-1.6,8.1-1.6
		c6.4,0,11.5,2,15.3,5.9c3.7,3.9,5.6,9.7,5.6,17.4c0,0.7,0,1.6-0.1,2.5c-0.1,0.9-0.1,1.7-0.2,2.4H1069c0.3,2.6,1.5,4.7,3.7,6.3
		s5.1,2.3,8.8,2.3c2.4,0,4.7-0.2,6.9-0.6c2.3-0.4,4.1-1,5.6-1.6l1.7,10.4c-0.7,0.3-1.6,0.7-2.8,1c-1.2,0.3-2.4,0.6-3.8,0.9
		c-1.4,0.3-2.9,0.5-4.5,0.6c-1.6,0.2-3.2,0.3-4.8,0.3c-4.1,0-7.6-0.6-10.7-1.8c-3-1.2-5.5-2.9-7.5-5c-2-2.1-3.5-4.6-4.4-7.5
		C1056.3,44.8,1055.8,41.7,1055.8,38.4z M1086,33.5c-0.1-1.1-0.2-2.2-0.6-3.2c-0.3-1-0.8-2-1.5-2.8c-0.7-0.8-1.5-1.5-2.5-2
		s-2.3-0.8-3.8-0.8c-1.4,0-2.7,0.2-3.7,0.7c-1,0.5-1.9,1.1-2.6,1.9c-0.7,0.8-1.2,1.7-1.6,2.8c-0.4,1.1-0.6,2.1-0.8,3.2H1086z"
				/>
				<Path
					d="M1121.4,51.5c2.4,0,4-0.2,5-0.7c1-0.5,1.5-1.4,1.5-2.7c0-1-0.6-1.9-1.9-2.7c-1.3-0.8-3.2-1.7-5.8-2.6
		c-2-0.7-3.8-1.5-5.5-2.3c-1.6-0.8-3-1.8-4.2-2.9c-1.2-1.1-2-2.5-2.7-4c-0.6-1.6-1-3.4-1-5.6c0-4.3,1.6-7.6,4.7-10.1
		c3.2-2.5,7.5-3.7,13-3.7c2.8,0,5.4,0.2,7.9,0.7c2.5,0.5,4.5,1,6,1.6l-2.2,10c-1.5-0.5-3.1-1-4.9-1.4c-1.8-0.4-3.7-0.6-5.9-0.6
		c-4,0-6,1.1-6,3.4c0,0.5,0.1,1,0.3,1.4c0.2,0.4,0.5,0.8,1,1.2c0.5,0.4,1.2,0.8,2.1,1.2c0.9,0.4,2,0.9,3.4,1.4c2.8,1,5.2,2.1,7,3.1
		c1.8,1,3.3,2.1,4.4,3.3c1.1,1.2,1.8,2.5,2.2,3.9s0.6,3.1,0.6,5c0,4.5-1.7,7.9-5,10.2c-3.4,2.3-8.1,3.4-14.3,3.4
		c-4,0-7.4-0.3-10.1-1c-2.7-0.7-4.5-1.3-5.6-1.7l2.2-10.4c2.2,0.9,4.4,1.5,6.7,2C1116.9,51.3,1119.2,51.5,1121.4,51.5z"
				/>
				<Path
					d="M1163.3,51.5c2.4,0,4-0.2,5-0.7c1-0.5,1.5-1.4,1.5-2.7c0-1-0.6-1.9-1.9-2.7c-1.3-0.8-3.2-1.7-5.8-2.6
		c-2-0.7-3.8-1.5-5.5-2.3c-1.6-0.8-3-1.8-4.2-2.9c-1.2-1.1-2-2.5-2.7-4c-0.6-1.6-1-3.4-1-5.6c0-4.3,1.6-7.6,4.7-10.1
		c3.2-2.5,7.5-3.7,13-3.7c2.8,0,5.4,0.2,7.9,0.7c2.5,0.5,4.5,1,6,1.6l-2.2,10c-1.5-0.5-3.1-1-4.9-1.4c-1.8-0.4-3.7-0.6-5.9-0.6
		c-4,0-6,1.1-6,3.4c0,0.5,0.1,1,0.3,1.4c0.2,0.4,0.5,0.8,1,1.2c0.5,0.4,1.2,0.8,2.1,1.2c0.9,0.4,2,0.9,3.4,1.4c2.8,1,5.2,2.1,7,3.1
		c1.8,1,3.3,2.1,4.4,3.3c1.1,1.2,1.8,2.5,2.2,3.9s0.6,3.1,0.6,5c0,4.5-1.7,7.9-5,10.2c-3.4,2.3-8.1,3.4-14.3,3.4
		c-4,0-7.4-0.3-10.1-1c-2.7-0.7-4.5-1.3-5.6-1.7l2.2-10.4c2.2,0.9,4.4,1.5,6.7,2C1158.8,51.3,1161.1,51.5,1163.3,51.5z"
				/>
				<Path
					d="M1217.1,36.7c0-4.1-0.5-7.1-1.6-8.8c-1.1-1.7-2.9-2.6-5.5-2.6c-0.8,0-1.6,0-2.5,0.1s-1.7,0.2-2.5,0.3v35.1h-12.9V16.9
		c1.1-0.3,2.4-0.6,3.8-0.9c1.5-0.3,3-0.6,4.7-0.9c1.6-0.3,3.3-0.5,5.1-0.6c1.7-0.1,3.4-0.2,5.1-0.2c3.3,0,5.9,0.4,8,1.3
		c2,0.8,3.7,1.8,5.1,3c1.8-1.3,4-2.4,6.3-3.1c2.4-0.7,4.6-1.1,6.6-1.1c3.6,0,6.6,0.5,8.9,1.5c2.3,1,4.2,2.4,5.6,4.3
		c1.4,1.8,2.3,4,2.8,6.6c0.5,2.5,0.8,5.4,0.8,8.5v25.6H1242V36.7c0-4.1-0.5-7.1-1.6-8.8c-1.1-1.7-2.9-2.6-5.5-2.6
		c-0.7,0-1.7,0.2-2.9,0.5c-1.2,0.3-2.3,0.8-3.1,1.3c0.4,1.3,0.7,2.7,0.8,4.2c0.1,1.5,0.2,3,0.2,4.7v24.8h-12.9V36.7z"
				/>
				<Path
					d="M1264.4,38.4c0-4,0.6-7.6,1.9-10.6c1.2-3,2.9-5.5,4.9-7.6c2-2,4.3-3.5,6.9-4.6c2.6-1,5.3-1.6,8.1-1.6
		c6.4,0,11.5,2,15.3,5.9c3.7,3.9,5.6,9.7,5.6,17.4c0,0.7,0,1.6-0.1,2.5c-0.1,0.9-0.1,1.7-0.2,2.4h-29.2c0.3,2.6,1.5,4.7,3.7,6.3
		s5.1,2.3,8.8,2.3c2.4,0,4.7-0.2,6.9-0.6c2.3-0.4,4.1-1,5.6-1.6l1.7,10.4c-0.7,0.3-1.6,0.7-2.8,1c-1.2,0.3-2.4,0.6-3.8,0.9
		c-1.4,0.3-2.9,0.5-4.5,0.6c-1.6,0.2-3.2,0.3-4.8,0.3c-4.1,0-7.6-0.6-10.7-1.8c-3-1.2-5.5-2.9-7.5-5c-2-2.1-3.5-4.6-4.4-7.5
		C1264.9,44.8,1264.4,41.7,1264.4,38.4z M1294.6,33.5c-0.1-1.1-0.2-2.2-0.6-3.2c-0.3-1-0.8-2-1.5-2.8c-0.7-0.8-1.5-1.5-2.5-2
		s-2.3-0.8-3.8-0.8c-1.4,0-2.7,0.2-3.7,0.7c-1,0.5-1.9,1.1-2.6,1.9c-0.7,0.8-1.2,1.7-1.6,2.8c-0.4,1.1-0.6,2.1-0.8,3.2H1294.6z"
				/>
				<Path
					d="M1317,16.9c2.2-0.6,5-1.2,8.5-1.8c3.5-0.5,7.1-0.8,10.9-0.8c3.9,0,7.1,0.5,9.6,1.5c2.6,1,4.6,2.4,6.1,4.3
		c1.5,1.8,2.6,4,3.2,6.6c0.6,2.5,1,5.4,1,8.5v25.6h-12.9V36.7c0-4.1-0.5-7.1-1.6-8.8c-1.1-1.7-3.1-2.6-6.1-2.6c-0.9,0-1.9,0-2.9,0.1
		c-1,0.1-2,0.2-2.8,0.3v35.1H1317V16.9z"
				/>
				<Path
					d="M1367.4,4l12.9-2.1v13.4h15.5V26h-15.5v16c0,2.7,0.5,4.9,1.4,6.5c1,1.6,2.9,2.4,5.7,2.4c1.4,0,2.8-0.1,4.3-0.4
		s2.8-0.6,4-1.1l1.8,10c-1.6,0.6-3.3,1.2-5.2,1.6s-4.2,0.7-7,0.7c-3.5,0-6.4-0.5-8.7-1.4c-2.3-0.9-4.1-2.3-5.5-4
		c-1.4-1.7-2.3-3.8-2.9-6.2c-0.5-2.4-0.8-5.1-0.8-8V4z"
				/>
			</G>
		</Svg>
	);
};
